import { createContext } from "react";

export const HashContext = createContext();
